export function SettingsCliPage() {
  return (
    <div className="space-y-6">
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-foreground">CLI Configuration</h1>
        <p className="text-muted-foreground">CLI integration settings, API keys, and default CLI selection.</p>
      </header>

      <div className="rounded-lg border border-border bg-card p-8 text-center">
        <svg className="mx-auto mb-3 h-10 w-10 text-muted-foreground/50" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z" />
        </svg>
        <h3 className="mb-1 text-sm font-medium text-foreground">CLI Settings</h3>
        <p className="text-sm text-muted-foreground">CLI integration settings (API keys, default CLI selection) are coming soon.</p>
      </div>
    </div>
  );
}